import React from "react"
import { Swiper, SwiperSlide } from "swiper/react"
import { Pagination, Autoplay } from "swiper"
import User1 from "../../assets/images/user1.webp"
import User2 from "../../assets/images/user2.webp"
import User3 from "../../assets/images/user3.webp"
import TestimonialsImg from "../../assets/images/testimonials-img.webp"
import { Link } from "gatsby"

const TestimonialStyleOne = () => {
  return (
    <>
      <div className="testimonials-area">
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-7 col-md-12">
              <div className="testimonials-content">
                <span className="sub-title">Bài viết</span>
                <h2><a href="/blog">Chia sẻ kiến thức về học sâu và thị giác máy tính</a></h2>

                <Swiper
                  slidesPerView={1}
                  pagination={{
                    clickable: true,
                  }}
                  autoplay={{
                    delay: 6500,
                    disableOnInteraction: true,
                    pauseOnMouseEnter: true,
                  }}
                  modules={[Pagination, Autoplay]}
                  className="testimonials-slides"
                >
                  <SwiperSlide>
                    <div className="single-testimonials-item">
                      <p>
                      Bài viết này mình sẽ giới thiệu về cách triển khai model detect (phát hiện) và recogize (nhận diện) chữ trong ảnh ngoại cảnh
                      </p>

                      <div className="client-info">
                        <div className="d-flex align-items-center">
                          <img src={User1} alt="User" />
                          <div className="title">
                            <h3>Nhận dạng chữ tiếng Việt trong ảnh ngoại cảnh</h3>
                            <span>APCV</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </SwiperSlide>

                  <SwiperSlide>
                    <div className="single-testimonials-item">
                      <p>
                      Nhận dạng ký tự quang học (Optical Character Recognition – OCR) là phần mềm có chức năng chuyển đổi hình ảnh chữ viết tay hoặc đánh máy thành các văn bản tài liệu. Công nghệ này hiện được phát triển thành nhiều ứng dụng hữu ích như dịch thuật theo thời gian thực, định danh khách hàng
                      </p>

                      <div className="client-info">
                        <div className="d-flex align-items-center">
                          <img src={User2} alt="User" />
                          <div className="title">
                            <h3>11 Dự án OCR mã nguồn mở</h3>
                            <span>APCV</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </SwiperSlide>

                  <SwiperSlide>
                    <div className="single-testimonials-item">
                      <p>
                      Xuất phát ý tưởng từ paper Attention Is All You Need, Transformer đã thực sự tạo nên một kiến trúc đột phá giúp giải quyết nhiều vấn đề tồn tại trong việc xử lý ngôn ngữ tự nhiên và gần đây đã mở rộng nhiều lĩnh vực trong đó có Computer Vision
                      </p>

                      <div className="client-info">
                        <div className="d-flex align-items-center">
                          <img src={User3} alt="User" />
                          <div className="title">
                            <h3>Nhận Dạng Tiếng Việt Sử Dụng Mô Hình Transformer và Attention</h3>
                            <span>APCV</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </SwiperSlide>
                </Swiper>
                
              </div>
            </div>

            <div className="col-lg-5 col-md-12">
              <div className="testimonials-image">
                <img src={TestimonialsImg} alt="Testimonials" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default TestimonialStyleOne
